import localeEn from '@angular/common/locales/en';

// Fallback for non-WebKit environments (e.g., desktop browsers)
if (!window.webkit || !window.webkit.messageHandlers) {
  console.warn('[WebKit] messageHandlers not found ');
  window.webkit = {
    messageHandlers: new Proxy(
      {},
      {
        get: () => ({
          postMessage: () => {
            console.warn('[WebKit] postMessage not found ');
          },
        }),
      },
    ),
  };
}

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from '@app/app.module';
import * as Sentry from '@sentry/angular';

import { PortalTrackingEvents } from '@app/utils/tracking-events';
import { Tracking } from '@app/services/tracking/tracking.service';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';

declare global {
  interface Window {
    makeClientTracker: (api: string, load: boolean) => any[];
    webkit?: {
      messageHandlers?: {
        [key: string]: {
          postMessage: (data: any) => void;
        };
      };
    };
  }
}

if (environment.production) {
  Sentry.init({
    // TODO release: environment.RELEASE,
    dsn: 'https://0bb7a4d7108e4f119363f8bb532b5685@o1146485.ingest.sentry.io/4504491483660288',
    integrations: [Sentry.browserTracingIntegration()],
    tracePropagationTargets: ['localhost'],
    tracesSampleRate: 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'Non-Error promise rejection captured',
      /scrollLeft/,
      /clarity\.js/,
      /webkit\.messageHandlers/,
      /Java object is gone/,
      /failed to fetch image/i,
      /Http failure response.*:\s*0 Unknown Error/,
      /expected expression, got '<'/,
    ],
  });

  enableProdMode();
}

registerLocaleData(localeEn);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

const appendTrackerScript = (trackingUrl = '') => {
  const script = document.createElement('script');

  script.type = 'text/javascript';
  script.async = true;
  script.src = `${trackingUrl}/assets/tracker.js`;
  script.onload = () => {
    if (typeof window.makeClientTracker === 'function') {
      const clientTrackerApi = `${trackingUrl}/images/ct.gif`;

      const clientTracker = window.makeClientTracker(clientTrackerApi, true) || [];

      window.track = function (meta) {
        clientTracker.push(meta);
      };

      Tracking.init(window.track);

      Tracking.patch({ leadPortalLink: document.location.pathname.substring(1) });

      Tracking.track(PortalTrackingEvents.quoteOpened);

      window.addEventListener('beforeunload', function () {
        Tracking.track(PortalTrackingEvents.quoteClosed);
      });
    }
  };

  document.body.appendChild(script);
};

appendTrackerScript(environment.TRACKING_URL as string);
